import { useEffect, useState } from 'react';
import { ModalProps } from '@features/Modal';
import './VerificationModal.scss';
import { Button } from '@shared/UI';

interface VerificationModalProps extends ModalProps {
    closeClick: (_?: any, shouldClose?: boolean) => void;
}

export const VerificationModal: React.FC<VerificationModalProps> = ({ onClose, closeClick }) => {
    const [active, setActive] = useState(true);

    const handleClose = () => {
        onClose?.();
        setActive(false);
    };

    useEffect(() => {
        document.documentElement.style.setProperty('--modal-z-index', active ? '12' : '13');
    }, [active]);

    return (
        <div className='feature-verification-modal'>
            <p className='feature-verification-modal__content'>
                Unsaved changes detected. Would you like to discard the modified information?
            </p>
            <div className='feature-verification-modal__buttons-container'>
                <Button
                    onClick={() => {
                        handleClose();
                        closeClick('', true);
                    }}
                >
                    Discard changes
                </Button>
                <Button onClick={handleClose}>Go Back</Button>
            </div>
        </div>
    );
};
